import Box from '@mui/material/Box'
import Container from '@mui/material/Container'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import LockOutlinedIcon from '@mui/icons-material/LockOutlined'
import Link from 'src/components/Link'
import Logo from 'template/logos/logo.svg'
import shopInfos from 'template/infos'

const logoSrc = typeof Logo === 'string' ? Logo : Logo.src

export default function CheckoutHeader() {
  return <Box component='header' data-checkout-header='modern' sx={{
    backgroundColor: 'var(--page-builder-nav-bg, #fff)',
    color: 'var(--page-builder-text, #102d59)',
    borderBottom: '1px solid rgba(16, 45, 89, .12)',
    '& a': { color: 'inherit' },
    '& a:focus-visible': { outline: '2px solid currentColor', outlineOffset: 4 },
  }}>
    <Container maxWidth='lg' sx={{
      display: 'grid', gridTemplateColumns: { xs: '1fr auto', sm: '1fr auto 1fr' },
      alignItems: 'center', gap: { xs: '4px 12px', sm: 3 }, py: { xs: 1, sm: 2 },
    }}>
      <Box sx={{ gridColumn: 1, gridRow: { xs: 2, sm: 1 }, justifySelf: 'start', '& a': {
        display: 'inline-flex', alignItems: 'center', gap: .75, minHeight: 44,
        fontSize: { xs: '.78rem', sm: '.875rem' }, textUnderlineOffset: '3px',
      } }}>
        <Link href='/warenkorb'><ArrowBackIcon sx={{ fontSize: 18 }} />Zurück zum Warenkorb</Link>
      </Box>
      <Box sx={{ gridColumn: { xs: '1 / -1', sm: 2 }, gridRow: 1, justifySelf: 'center', '& a': { display: 'block' } }}>
        <Link href='/' aria-label={`${shopInfos.name} – Startseite`}>
          <Box component='img' src={logoSrc} alt={shopInfos.name} width={216} height={44}
            sx={{ display: 'block', objectFit: 'contain', width: { xs: 170, sm: 216 }, height: { xs: 38, sm: 44 } }} />
        </Link>
      </Box>
      <Box sx={{
        gridColumn: { xs: 2, sm: 3 }, gridRow: { xs: 2, sm: 1 }, justifySelf: 'end',
        display: 'flex', alignItems: 'center', gap: .6, fontSize: { xs: '.72rem', sm: '.8rem' }, whiteSpace: 'nowrap',
        color: 'var(--page-builder-muted, #465570)',
      }}><LockOutlinedIcon sx={{ fontSize: 17 }} />Sicher bestellen</Box>
    </Container>
  </Box>
}
